// extracted by mini-css-extract-plugin
export var actionButtonsColumn = "styles-module--actionButtonsColumn--a1a24";
export var columns = "styles-module--columns--08fbe";
export var draggableImages = "styles-module--draggableImages--a2464";
export var imagesColumn = "styles-module--imagesColumn--92a2b";